import { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import styles from './Layout.module.css';
import { AuthContext } from '@/contexts/AuthContext';
import { MainContextProvider } from '@/contexts/providers/MainContextProvider';
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Profile from '@/pages/Profile';
import Signup from '@/pages/Signup';
import PasswordResetInit from '@/pages/PasswordReset/init';
import PasswordResetFinish from '@/pages/PasswordReset/finish';
import UserActivation from '@/pages/UserActivation';
import Catalog from '@/pages/Catalog';
import Admin from '@/pages/Admin';
import FAQs from '@/pages/FAQs';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import ConfirmLeadData from '@/pages/ConfirmLeadData';
import CarDetail from '@/pages/CarDetail';
import Loader from '../UI/Loader';
import Maintenance from '@/pages/Maintenance';

interface Props {}

const Layout = ({ ...props }: Props) => {
	const authCtx = useContext(AuthContext);
	const isMaintenance = process.env.REACT_APP_MAINTENANCE === 'true';

	if (authCtx.isLoading) {
		return <Loader visible={authCtx.isLoading} />;
	}

	// Caso: App sotto manutenzione
	if (isMaintenance) {
		return (
			<div className={styles.container}>
				<main {...props} className={styles.main_container}>
					<Routes>
						<Route path="/home" element={<Home />} />
						<Route path="/" element={<Navigate replace to="/home" />} />
						<Route path="*" element={<Maintenance />} />
					</Routes>
				</main>
			</div>
		);
	}

	if (!authCtx.isLoggedIn) {
		return (
			<Routes>
				<Route path="/login" element={<Login />} />
				<Route path="/reset/password/init" element={<PasswordResetInit />} />
				<Route path="/reset/password/finish" element={<PasswordResetFinish />} />
				<Route path="/signup" element={<Signup />} />
				<Route path="/account/activate" element={<UserActivation />} />
				<Route path="/wibro-privacy-policy" element={<PrivacyPolicy />} />
				<Route path="/frequently-asked-questions" element={<FAQs />} />
				<Route path="/confirm-consent" element={<ConfirmLeadData />} />

				{/* Home per non autenticati e wildcard */}
				<Route path="/home" element={<Home />} />
				<Route path="*" element={<Navigate replace to="/home" />} />
			</Routes>
		);
	} else {
		return (
			<div className={styles.container}>
				<MainContextProvider>
					<main {...props} className={styles.main_container}>
						<Routes>
							<Route path="/admin-area" element={<Admin />} />
							<Route path="/profile" element={<Profile />} />
							<Route path="/catalog" element={<Catalog />} />
							<Route path="/car/:carId" element={<CarDetail />} />
							<Route path="/frequently-asked-questions" element={<FAQs />} />
							<Route path="/reset/password/init" element={<PasswordResetInit />} />

							{/* Home per non autenticati e wildcard */}
							<Route path="/home" element={<Home />} />
							<Route path="*" element={<Navigate replace to="/home" />} />
						</Routes>
					</main>
				</MainContextProvider>
			</div>
		);
	}
};

export default Layout;
